import Http from "../../http/client";

export default async (payload) => {
  const response = await Http.post('admin/user/notes', payload);
  return response.data;
}
